import * as React from 'react';
import SomethingWentWrongPage from '../pages/generalPages/SomethingWentWrongPage';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    localStorage.clear();
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <SomethingWentWrongPage />;
    }
    return this.props.children;
  }
}